import{__decorate as o,n as t}from"../d4cffba7.js";import{n as i,r,y as e}from"../493beda6.js";import{defaultStyles as s}from"../styles.js";import{exportParts as c}from"../directives/ExportParts.js";import{Popover as a}from"./Popover.js";import"../icons/monochrome/help.js";import"../f75f919c.js";import"../af1106fb.js";let p=class extends i{static get styles(){return[s,r`
        #trigger {
          --cai-icon-width: var(--cai-popover-icon-width, 16px);
          --cai-icon-height: var(--cai-popover-icon-height, 16px);
          --cai-icon-fill: var(--cai-popover-icon-fill, #a8a8a8);
          cursor: pointer;
        }
        #content {
          max-width: 180px;
        }
      `]}render(){return e`
      <cai-popover
        placement="left"
        exportparts=${c(a.cssParts)}
      >
        <cai-icon-help slot="trigger" id="trigger"></cai-icon-help>
        <div id="content" slot="content">
          <slot name="content"></slot>
        </div>
      </cai-popover>
    `}};p.cssParts=Object.assign({},a.cssParts),p=o([t("cai-tooltip")],p);export{p as Tooltip};
